// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/get-token-request-schema',
  type: 'object',
  required: [],
  properties: {
    userName: {
      type: 'string',
      nullable: true,
    },
    password: {
      type: 'string',
      nullable: true,
    },
    shareId: {
      type: 'string',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
